// import Colcade from "colcade";
import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded"

let masonry = document.querySelector('.masonry')
imagesLoaded(masonry, () => {
    new Masonry(masonry, {
        // columns: ".masonry-col",
        itemSelector: ".masonry-item"
    });
})

/*let masonry = new Colcade(".masonry", {
    columns: ".masonry-col",
    items: ".masonry-item"
});*/
